import i18n from '@/i18n/index';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllDispositifs, updateNomenclatureDispositif } from '@/api/gabed/dispositif/index';
import { getAll as getAllNomenclatures } from '@/api/nomenclatureType/index';
import genererpatrimoineNomenclature from '@/services/import/patrimoineNomenclature/genererPatrimoineNomenclature';
import { columns } from '@/services/import/patrimoineNomenclature/templatePatrimoineNomenclature';
import store from '@/store/store';

export function ErrorPatrimoineNomenclatureTranslate(errors) {
  if (!errors || !Array.isArray(errors)) return [];
  return errors.map(error => {
    if (error.endsWith('_IS_REQUIRED')) {
      return i18n.t('importationPatrimoineNomenclature.errors.requiredPropertie', { label: error.split('_')[0] });
    }
    if (error.includes('_MAX_LENGTH_')) {
      return i18n.t('importationPatrimoineNomenclature.errors.maxLengthPropertie', { label: error.split('_')[0], length: error.split('_')[error.split('_').length - 1] });
    }
    if (error.includes('_DISPOSITIF_NOT_FOUND')) {
      return i18n.t('importationPatrimoineNomenclature.errors.dispositifNotFound', { name: error.split('_')[0] });
    }

    if (error.includes('_NOMENCLATURE_NOT_FOUND')) {
      return i18n.t('importationPatrimoineNomenclature.errors.nomenclatureNotFound', { name: error.split('_')[0] });
    }
    switch (error) {
      default:
        return 'Un problème est survenu';
    }
  }).join(' - ');
}

function validationLigne(ligne, dispositifs, nomenclatures) {
  const error = {
    numLigne: ligne.numLigne,
    errors: [],
  };
  const dispositif = dispositifs.find(t => t.code === ligne.codeDispositif);
  if (ligne.codeDispositif && !dispositif) error.errors.push(`${ligne.codeDispositif}_DISPOSITIF_NOT_FOUND`);

  const nomenclature = nomenclatures.find(t => t.libelle === ligne.nomenclature);
  if (ligne.nomenclature && !nomenclature) error.errors.push(`${ligne.codeDispositif}_NOMENCLATURE_NOT_FOUND`);

  columns.forEach(column => {
    const columnErrors = column.checkValue(ligne[column.key]);
    if (columnErrors.length > 0) error.errors = error.errors.concat(columnErrors);
  });

  if (error.errors.length > 0) throw error;
}

export async function makePatrimoineNomenclatureGenerated(file) {
  const lignes = file[0];
  const patrimoineNomenclatures = [];
  const errors = [];

  const dispositifs = (await getAllDispositifs({
    query: {
      societeId: store.getters['societe/societeActiveId'],
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  const nomenclatures = (await getAllNomenclatures({
    query: {
      societeId: store.getters['societe/societeActiveId'],
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  // saut de la premiere vu qu'on a 2 lignes d'entete
  for (let i = 1; i < lignes.length; i += 1) {
    try {
      validationLigne(lignes[i], dispositifs, nomenclatures);
    } catch (e) {
      errors.push(e);
    }
  }
  if (errors.length > 0) {
    errors.unshift({ total: lignes.length - 1, totalErrors: errors.length });
    throw errors;
  }

  // saut de la premiere vu qu'on 2 lignes d'entete
  for (let i = 1; i < lignes.length; i += 1) {
    const patrimoineNomenclature = genererpatrimoineNomenclature(lignes[i],
      dispositifs, nomenclatures);
    patrimoineNomenclatures.push(patrimoineNomenclature);
  }

  return patrimoineNomenclatures;
}

export async function makePatrimoineNomenclatureImport(patrimoineNomenclatures) {
  for (let i = 0; i < patrimoineNomenclatures.length; i += 1) {
    const patrimoineNomenclature = patrimoineNomenclatures[i];
    // eslint-disable-next-line no-await-in-loop
    await updateNomenclatureDispositif(patrimoineNomenclature);
  }
}
